module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATBAMAAABmV+C7AAAAIVBMVEUAAADKES/IETDIEC7IFDLJES7LEi7MES/JETDKEjXJEC5AZCHYAAAACnRSTlMAlGvMM49TPHUdFjpN2gAAACpJREFUCNdjKFKCAXWGqFUwsJQhURAGxBiIAMh6UdggwLIYTNGdzSkBpgDH3x5uslf6nAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/zipcode.png
// module id = mv7k
// module chunks = 0 58 59 61 62 63